import { Link } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import { isTruthy } from "../../utils/isTruthy";
import { buildNavigationTree } from "../../utils/navigation";
import { FacebookIcon, InstagramIcon, LinkedInIcon, Logo, MailIcon, MapIcon, YoutubeIcon } from "../Molecules/icons";
var socials = [
    {
        link: "https://www.facebook.com/unisgmba",
        title: "Facebook",
        icon: FacebookIcon
    },
    {
        link: "http://www.youtube.com/unisgmba",
        title: "Youtube",
        icon: YoutubeIcon
    },
    {
        link: "https://instagram.com/unisgmba/",
        title: "Instagram",
        icon: InstagramIcon
    },
    {
        link: "https://www.linkedin.com/school/743022/",
        title: "LinkedIn",
        icon: LinkedInIcon
    }
];
export function Footer(props) {
    var items = buildNavigationTree(props.footerNavigation.items.filter(isTruthy));
    return /*#__PURE__*/ React.createElement("footer", {
        className: "bg-green-900 container-page flex flex-col lg:flex-row pb-[6.25rem] lg:pb-0 pt-[3.25rem] lg:pt-[7.5rem] lg:px-[5.75rem] gap-[2.375rem] lg:gap-[8.9rem] lg:h-[30.5625rem]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-12"
    }, /*#__PURE__*/ React.createElement(Logo, {
        variant: "secondary"
    }), /*#__PURE__*/ React.createElement(Accreditations, {
        className: "hidden lg:flex"
    })), /*#__PURE__*/ React.createElement("nav", {
        className: "grid grid-cols-2 md:grid-cols-4 gap-y-11",
        "aria-label": "Footer"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:col-span-2 md:max-h-[10.5rem]"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "text-white text-[0.9375rem] font-semibold leading-sm mb-1"
    }, "Quicklinks"), /*#__PURE__*/ React.createElement("div", {
        className: "grid md:grid-rows-[repeat(4,_minmax(auto,_1fr))] md:grid-flow-col md:auto-cols-fr"
    }, items.filter(isTruthy).map(function(item) {
        return /*#__PURE__*/ React.createElement(Link, {
            key: item.title,
            href: item.target,
            className: "text-[0.9375rem] leading-2xl text-white font-normal hover:text-green-100 hover:underline-offset-2 hover:underline transition focus-white self-start"
        }, item.title);
    }))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h2", {
        className: "text-white text-[0.9375rem] font-semibold leading-sm mb-1"
    }, "Privacy"), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col"
    }, props.privacyNavigation.items.filter(isTruthy).map(function(item) {
        return /*#__PURE__*/ React.createElement(Link, {
            key: item.title,
            href: item.target,
            className: "text-[0.9375rem] leading-2xl text-white font-normal hover:text-green-100 hover:underline-offset-2 hover:underline transition focus-white"
        }, item.title);
    }))), /*#__PURE__*/ React.createElement(Contacts, null), /*#__PURE__*/ React.createElement(Accreditations, {
        className: "flex lg:hidden col-span-full"
    })));
}
var Accreditations = function(param) {
    var className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("flex flex-row place-self-start gap-12 items-center", className)
    }, /*#__PURE__*/ React.createElement("img", {
        width: "58",
        height: "36",
        src: "/images/equis.png",
        alt: "EQUIS Accredited"
    }), /*#__PURE__*/ React.createElement("img", {
        width: "38",
        height: "53",
        src: "/images/aacsb.png",
        alt: "AACSB Accredited"
    }), /*#__PURE__*/ React.createElement("img", {
        width: "52",
        height: "48",
        src: "/images/amba.png",
        alt: "Association of MBAs Accredited"
    })));
};
var Contacts = function() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex gap-2 flex-col col-span-full md:col-span-1"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "text-white text-[0.9375rem] font-semibold leading-sm"
    }, "Connect with Us"), /*#__PURE__*/ React.createElement("ul", {
        className: "flex flex-row gap-4 items-center pb-3"
    }, socials.map(function(social) {
        return /*#__PURE__*/ React.createElement("li", {
            key: social.title
        }, /*#__PURE__*/ React.createElement("a", {
            key: social.link,
            href: social.link,
            title: social.title,
            className: "hover:opacity-70 transition focus-white"
        }, /*#__PURE__*/ React.createElement(social.icon, null)));
    })), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row gap-4 items-baseline"
    }, /*#__PURE__*/ React.createElement(MapIcon, {
        "aria-hidden": "true"
    }), /*#__PURE__*/ React.createElement("p", {
        className: "text-[0.9375rem] leading-2xl text-white font-normal break-words"
    }, "Rosenbergstrasse 20-22, 9000 St.Gallen, Switzerland")), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row gap-4 items-center"
    }, /*#__PURE__*/ React.createElement(MailIcon, {
        "aria-hidden": "true"
    }), /*#__PURE__*/ React.createElement("a", {
        href: "mailto:mba@unisg.ch",
        title: "email",
        className: "text-[0.9375rem] leading-2xl text-white font-normal hover:opacity-70 transition focus-white hover:text-green-100 hover:underline-offset-2 hover:underline transition"
    }, "mba@unisg.ch")));
};
